var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgApprovedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0739 7.49935L12.2662 10.6353C11.1536 11.878 10.5974 12.4993 9.86552 12.4993C9.13368 12.4993 8.5774 11.878 7.46483 10.6353L6.74052 9.82632M19.2405 9.99935C19.2405 14.6017 15.5096 18.3327 10.9072 18.3327C6.30481 18.3327 2.57385 14.6017 2.57385 9.99935C2.57385 5.39698 6.30481 1.66602 10.9072 1.66602C15.5096 1.66602 19.2405 5.39698 19.2405 9.99935Z",
    stroke: "#F6F6F6",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedIcon);
export default __webpack_public_path__ + "static/media/approvedIcon.abcc6f1b2115da7b60e505590ab88edf.svg";
export { ForwardRef as ReactComponent };